import { getCookie } from "functions";
import Router from "next/router";
import { isLocale } from "translations/types";
import { locales, defaultLocale } from "translations/config";

export const redirect = (ctx, lang = "en", options = {}) => {
  var { allow = false, redirectTo = {} } = options || {};

  if (isLocale(lang) && !allow) {
    return false;
  }
  if (!isLocale(lang)) {
    // Try to extract a valid locale prefix from the invalid lang
    var validLocale = defaultLocale;
    for (var i = 0; i < locales?.length; i++) {
      if (lang && lang.startsWith(locales?.[i])) {
        validLocale = locales?.[i];
        break;
      }
    }

    var redirectPath = `/${validLocale}`;
    var currentPath = null;

    if (ctx?.asPath) {
      currentPath = ctx?.asPath?.split("?")[0];
    } else if (ctx?.req?.url) {
      currentPath = ctx?.req?.url?.split("?")[0];
    } else if (typeof window !== "undefined") {
      currentPath = window.location.pathname;
    }

    if (currentPath) {
      var invalidLocalePattern = new RegExp(`^/${lang}(/.*)?$`);
      if (invalidLocalePattern.test(currentPath)) {
        var pathAfterLocale = currentPath.replace(new RegExp(`^/${lang}`), "");
        redirectPath = `/${validLocale}${pathAfterLocale}`;
      }
    }

    return handleRedirect(ctx, { href: "/[lang]", as: redirectPath });
  }


  var _id = getCookie("_id", ctx?.req);
  var authToken = getCookie("authToken", ctx?.req);
  var isGuestByCookie = getCookie("isGuest", ctx?.req);
  var isGuest = isGuestByCookie || !_id || !authToken;
  var status = [];

  // if (isGuestByCookie) status.push('guestByCookie')
  if (isGuest) status.push("guest");
  else status.push("!guest");

  var canAccessPage =
    allow.filter((value) => status.includes(value)).length > 0;

  if (canAccessPage) return false;

  var redirectUrl = createRedirectUrl(redirectTo, lang);
  return handleRedirect(ctx, redirectUrl);
};

const createRedirectUrl = ({ href, as }, lang) => {
  href = href === "/" ? "" : href;
  var pre_href = lang ? "/[lang]" : "";
  var pre_as = lang ? `/${lang}` : "";

  var redirectUrl = {
    href: `${pre_href}${href}`,
    as: as ? `${pre_as}${as}` : `${pre_as}${href}`,
  };

  return redirectUrl;
};

const handleRedirect = ({ req, res }, { href, as }) => {
  if (req) {
    res.writeHead(302, { Location: as });
    res.end();
  } else {
    Router.push(href, as);
  }

  return true;
};
